(function ($) {
	
	$.fn.podcastPlatforms = function () {
		
		var elem = $(this),
		    targets = elem.find('.js-copy__target'),
		    triggers = elem.find('.js-copy__trigger'),
            notice = elem.find('.js-copy__notice'),
            platform = elem.find('.js-platform__trigger');
		
		var init = function () {

            // Bind the click
			triggers.off('click').on('click', function(evt) {

                evt.preventDefault();

                if (targets.val()) {
					
					copyToClipboard();
					notice.html('<p>Copied to Clipboard</p>');
					
				} else {
					
					notice.html('<p>Click an option first</p>');
					
				}

            });


            function copyToClipboard() {
				/* Get the text field */
				var copyText = targets;
				
				/* Select the text field */
				copyText.select();
				
				/* Copy the text inside the text field */
				document.execCommand("copy");
			}


            platform.off('click').on('click', function(evt) {

                evt.preventDefault();

                var url = $(this).attr('value');
				targets.val(url);

            });
			
		};
		
		init();
		
		return this;
		
	};
	
}(jQuery));